const isArray = obj => {
    return Array.isArray(obj);
};

const isObject = obj => {
    return obj != null && "object" == typeof obj && !isArray(obj);
};

const find = (ref, stack, root) => {
    if (ref == "$") {
        return root;
    } else if (ref == "@") {
        return stack[stack.length - 1];
    } else if (ref == "..") {
        return stack[stack.length - 2];
    } else if (ref == "../..") {
        return stack[stack.length - 3];
    } else {
        let refPath = ref.split(/[.[\]]/);
        let target;
        for (let refItem of refPath) {
            if (refItem == "$") {
                target = root;
                continue;
            }
            if (refItem == "") {
                continue;
            }
            target = target[refItem];
        }
        return target;
    }
}

const parseRecurve = (obj, index, last, stack, root) => {
    if (isObject(obj)) {
        let ref = obj.$ref;
        if (ref) {
            let replaceNode = find(ref, stack, root);
            last[index] = replaceNode;
            return;
        }
        for (let item in obj) {
            stack.push(obj);
            parseRecurve(obj[item], item, obj, stack, root);
            stack.pop();
        }
    } else if (isArray(obj)) {
        for (let i=0; i<obj.length; i++) {
            stack.push(obj);
            parseRecurve(obj[i], i, obj, stack, root);
            stack.pop();
        }
    }
};

const parse = obj => {
    // 如果是字符串，先解析为对象
    if (typeof obj == "string") {
        obj = JSON.parse(obj);
    }
    parseRecurve(obj, null, null, [], obj);
    return obj;
};

const JsonDeloop = {
    parse,
    isArray,
    isObject
};

export default JsonDeloop;